import useStyleOptions from './useStyleOptions';

export default function useAvatarForUser() {
  const [{ userAvatarImage: image, userAvatarInitials: initials }] = useStyleOptions();

  return [
    {
      image,
      initials
    }
  ];
}
